<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold" style="margin-bottom: 0 !important;">{{ activeUserInfo.first_name }} {{ activeUserInfo.last_name }}</p>
      <small>{{ activeUserInfo.email_address }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer sm:relative sm:right-3">

      <div class="con-img ml-3">
        <img :src="activeUserInfo.firm_avatar_url || require('../../../../../public/profile.png')" alt="user-img" width="40" height="40" class="mobile-profile object-cover rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push({ path: '/settings', query: { setting: 'personal',profile:'profile' }}).catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>

<!--          <li-->
<!--            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
<!--            @click="$router.push('/apps/email').catch(() => {})">-->
<!--            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Inbox</span>-->
<!--          </li>-->

<!--          <li-->
<!--            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
<!--            @click="$router.push('/apps/todo').catch(() => {})">-->
<!--            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Tasks</span>-->
<!--          </li>-->

<!--          <li-->
<!--            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
<!--            @click="$router.push('/apps/chat').catch(() => {})">-->
<!--            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Chat</span>-->
<!--          </li>-->

<!--          <li-->
<!--            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
<!--            @click="$router.push('/apps/eCommerce/wish-list').catch(() => {})">-->
<!--            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Wish List</span>-->
<!--          </li>-->

<!--          <vs-divider class="m-1" />-->
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

  </div>
</template>

<script>

import axios from "@/axios";

export default {
  watch:{
    activeUserInfo:{
      handler  :(value) => {
        return value
      },
      deep     :true,
      immediate:true
    }
  },
  computed: {
    activeUserInfo: {
      get () {
        const model_profile = this.$store.state.update_profile
        return model_profile || JSON.parse(localStorage.getItem('user'))
      },
      set(newVal) {
        localStorage.setItem('user', JSON.stringify(newVal))
      }
    },
  },
  methods: {
    async logout () {
        if (localStorage.getItem('accessToken')) {
          this.$vs.loading()
          await axios.post('/account/firebase/token/',{web_client_token: null,phone_client_token: null}).then(()=> {})
          this.$router.push('/login').catch(() => {})
          localStorage.removeItem('user')
          localStorage.removeItem('accessSt')
          this.$store.commit('UPDATE_PROFILE',null)
          localStorage.removeItem('accessToken')
          localStorage.removeItem('myPermissions')
          localStorage.removeItem('expired_account')
          this.$store.commit('PERMISSIONS',null)
          localStorage.removeItem('template_type')
          localStorage.removeItem('currency_symbol')
          this.$vs.loading.close()
        }
    }
  },
}
</script>


<style>
  @media (max-width: 768px) {
    .mobile-profile{
      position: relative;
      right: 1em;
    }
  }
</style>
